import React, { Suspense, lazy } from 'react';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import BaseLayout from './layouts/BaseLayout';
import PublicLayout from './layouts/PublicLayout';
import AppLayout from './layouts/AppLayout';
import PreviewPage from '../components/preview/PreviewPage';
import { LoginPage } from '../pages';
import SkeletonPage from '../components/skeleton/SkeletonPage';
import PageTransition from '../components/utils/PageTransition';

const ProjectsPage = lazy(() => import('../pages/ProjectsPage'));
const DashboardPage = lazy(() => import('../pages/DashboardPage'));
const CapillaryPressurePage = lazy(() => import('../pages/CapillaryPressurePage'));
const KrAnalysisPage = lazy(() => import('../pages/KrAnalysisPage'));
const ZonesPage = lazy(() => import('../pages/ZonesPage'));
const CorrelationPage = lazy(() => import('../pages/CorrelationPage'));
const KrPcModelPage = lazy(() => import('../pages/KrPcModelPage'));
const GheInputsPage = lazy(() => import('../pages/GheInputsPage'));
const AnalogueTablesPage = lazy(() => import('../pages/AnalogueTablesPage'));
const KrelPcSelectionPage = lazy(() => import('../pages/KrelPcSelectionPage'));
const IxTablesPage = lazy(() => import('../pages/IxTablesPage'));
const SamplesSummaryPage = lazy(() => import('../pages/SamplesSummaryPage'));
const MultiAnalysisPage = lazy(() => import('../pages/MultiAnalysisPage'));
const SwHeightPage = lazy(() => import('../pages/SwHeightPage'));

const withTransition = (Component: React.LazyExoticComponent<React.ComponentType<any>>) => (
  <Suspense fallback={<SkeletonPage />}>
    <PageTransition>
      <Component />
    </PageTransition>
  </Suspense>
);

const router = createBrowserRouter(
  [
    {
      element: <BaseLayout />,
      children: [
        {
          element: <PublicLayout />,
          children: [
            { path: '/login', element: <LoginPage /> },
          ],
        },
        {
          element: <AppLayout />,
          children: [
            { path: '/projects', element: withTransition(ProjectsPage) },
            { path: '/dashboard', element: withTransition(DashboardPage) },
            { path: '/capillary-pressure', element: withTransition(CapillaryPressurePage) },
            { path: '/kr-analysis', element: withTransition(KrAnalysisPage) },
            { path: '/zones', element: withTransition(ZonesPage) },
            { path: '/correlation', element: withTransition(CorrelationPage) },
            { path: '/kr-pc-model', element: withTransition(KrPcModelPage) },
            { path: '/ghe-inputs', element: withTransition(GheInputsPage) },
            { path: '/analogue-tables', element: withTransition(AnalogueTablesPage) },
            { path: '/krel-pc-selection', element: withTransition(KrelPcSelectionPage) },
            { path: '/ix-tables', element: withTransition(IxTablesPage) },
            { path: '/samples-summary', element: withTransition(SamplesSummaryPage) },
            { path: '/multi-analysis', element: withTransition(MultiAnalysisPage) },
            { path: '/sw-height', element: withTransition(SwHeightPage) },
          ],
        },
        { index: true, element: <Navigate to="/login" replace /> },
        // Redirect any unknown route to login
        { path: '*', element: <Navigate to="/login" replace /> },
      ],
    },
  ],
  { basename: '/' }
);

const Router = () => <RouterProvider router={router} />;

export default Router;
